// extracted by mini-css-extract-plugin
export var card = "_87-0";
export var expandedCard = "_87-2";
export var paginated = "_87-1";